export default "__VITE_ASSET__CnC7vnse__"